import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';
import { ENV } from './env';

export const msalConfig: Configuration = {
  auth: {
    clientId: ENV.MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${ENV.MSAL_TENANT_ID}`,
    redirectUri: ENV.MSAL_REDIRECT_URI,
    postLogoutRedirectUri: ENV.MSAL_REDIRECT_URI,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:   console.error(message); break;
          case LogLevel.Warning: console.warn(message);  break;
          case LogLevel.Info:
            if (ENV.IS_DEVELOPMENT) console.info(message);
            break;
          default: break;
        }
      },
      logLevel: ENV.IS_DEVELOPMENT ? LogLevel.Verbose : LogLevel.Error,
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: ['User.Read', 'openid', 'profile', 'email'],
};

/** Employee submits request - send mail as self */
export const graphMailSendScopes = ['https://graph.microsoft.com/Mail.Send'] as const;

/**
 * Manager approves/rejects CompOff - backend needs a delegated Graph token
 * to search the manager's inbox and reply in the original email thread.
 * Mail.Read + Mail.Send (not Mail.ReadWrite) keeps the required permissions minimal.
 */
export const graphMailApproveScopes = [
  'https://graph.microsoft.com/Mail.Send',
  'https://graph.microsoft.com/Mail.Read',
] as const;
